@if (isVisible) {
<div class="loadingOverlay animHost" [ngStyle]="cssVarsForScene()" [attr.data-mode]="mode" role="status"
    aria-live="polite">
    <section class="stage" aria-hidden="true">
        <div class="stageFrame">
            <app-loading-logo [orb]="orb" [eye]="eye" [mode]="mode" [particles]="particles" [showEyelids]="showEyelids"
                [showBrackets]="showBrackets" [particleVars]="particleVars">
            </app-loading-logo>
        </div>
    </section>
    <span class="srOnly">Processing</span>
</div>
}
